import { render } from "./SaleFooter.vue?vue&type=template&id=0d2a9fb2&scoped=true"
import script from "./SaleFooter.vue?vue&type=script&lang=js"
export * from "./SaleFooter.vue?vue&type=script&lang=js"

import "./SaleFooter.vue?vue&type=style&index=0&id=0d2a9fb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2a9fb2"]])

export default __exports__